import { Controller } from "@hotwired/stimulus"

/**
 * Contact Invite Controller
 * 
 * Handles inviting contacts via SMS or WhatsApp
 */
export default class extends Controller {
    static values = {
        phoneNumber: String,
        message: String
    }

    /**
     * Get phone number from value or button data attribute
     */
    getPhoneNumber(event) {
        const phoneNumber = this.hasPhoneNumberValue ? this.phoneNumberValue : event.currentTarget.dataset.phoneNumber
        return phoneNumber || null
    }

    /**
     * Get message from value or button data attribute
     */
    getMessage(event) {
        const message = this.hasMessageValue ? this.messageValue : event.currentTarget.dataset.message
        return message || ""
    }

    /**
     * Invite via SMS
     */
    inviteViaSMS(event) {
        event.preventDefault()
        event.stopPropagation()

        const phoneNumber = this.getPhoneNumber(event)
        const message = encodeURIComponent(this.getMessage(event))

        if (!phoneNumber) {
            console.error("No phone number available")
            return
        }

        // Remove any non-digit characters except +
        const cleanPhone = phoneNumber.replace(/[^\d+]/g, '')

        // Open SMS app with pre-filled message
        const smsUrl = `sms:${cleanPhone}?body=${message}`
        window.location.href = smsUrl
    }

    /**
     * Invite via WhatsApp
     */
    inviteViaWhatsApp(event) {
        event.preventDefault()
        event.stopPropagation()

        const phoneNumber = this.getPhoneNumber(event)
        const message = encodeURIComponent(this.getMessage(event))

        if (!phoneNumber) {
            console.error("No phone number available")
            return
        }

        // Remove any non-digit characters except +
        let cleanPhone = phoneNumber.replace(/[^\d+]/g, '')
        
        // Remove leading + if present (WhatsApp format doesn't use +)
        if (cleanPhone.startsWith('+')) {
            cleanPhone = cleanPhone.substring(1)
        }

        // Open WhatsApp with pre-filled message
        const whatsappUrl = `https://wa.me/${cleanPhone}?text=${message}`
        window.open(whatsappUrl, '_blank')
    }
}

